import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET short-messages/app/v1/whatsapp/phone-numbers
 */
export const getWhatsAppNumbers = (...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('short-messages/app/v1/whatsapp/phone-numbers', {
    query: {
      includeNonConfiguredForSending: false
    }
  });
};